<google-map
    maxZoom="17"
    mapId="storytelling-map"
    class="st-map-view-google-map"
    [height]="height()"
    [width]="width()"
    [zoom]="mapZoom()"
    [options]="options()"
    (mapInitialized)="mapInit()"
    (zoomChanged)="updateCurrentZoom()"
    (centerChanged)="updateCurrentCenter()"
    (boundsChanged)="updateCurrentBounds()">
    <map-marker-clusterer (clusterClick)="markerClustererClicked($event)">
        @for (marker of markerData(); track marker?.uniqueId) {
            <map-advanced-marker
                ref-mapMarker
                class="map-marker"
                [position]="{
                    lat: marker.latitude,
                    lng: marker.longitude,
                }"
                [options]="{
                    gmpClickable: true,
                    title: marker.labelOptions?.text ? marker.labelOptions.text : '',
                }"
                [title]="marker.labelOptions?.text ? marker.labelOptions.text : ''"
                (mapClick)="markerClick(marker)" />
        }
        <ng-container>
            <map-info-window>
                @for (item of currentOpenedItems(); track item?.Guid) {
                    <ng-container *ngTemplateOutlet="itemTemplate(); context: { $implicit: item }" />
                }
                <ng-container *ngTemplateOutlet="footerTemplate()" />
            </map-info-window>
        </ng-container>
    </map-marker-clusterer>
    @if (!mapLockLocation()) {
        <button
            class="st-map-view-google-map__button__add buttons"
            (click)="zoomIn()">
            <mat-icon>add</mat-icon>
        </button>
        <button
            class="st-map-view-google-map__button__remove buttons"
            (click)="zoomOut()">
            <mat-icon>remove</mat-icon>
        </button>
    }
</google-map>
